export const API_BASE_URL = "https://backend-vcb7oopywq-uc.a.run.app";
export const MAX_RESULTS = 10;
export const DEFAULT_LANGUAGE = "en";
